<template>
    <div class="metafileds">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="metafileds"
            :loading="loading"
            :menuAuth="menuAuth"
        ></search-tool>

        <div :class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    align="center"
                ></el-table-column>
                <el-table-column
                    align="left"
                    label="Name"
                    prop="name"
                    min-width="220"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    align="left"
                    label="Key"
                    prop="key"
                ></el-table-column>
                <el-table-column
                    align="left"
                    label="Type"
                    prop="type"
                ></el-table-column>
                <el-table-column
                    align="left"
                    label="Created On"
                    prop="created_at"
                ></el-table-column>
                <el-table-column label="Operation" align="left" width="200">
                    <template slot-scope="scope">
                        <template v-for="item in scope.row.authority">
                            <el-button
                                type="text"
                                size="mini"
                                :class="item.class"
                                :key="item.id"
                                v-if="item.status_flag !== 4"
                                @click="rowDo(item, scope.row)"
                                >{{ item.name }}</el-button
                            >
                            <delPopConfirm
                                v-else
                                :key="item.id"
                                :btnClassName="'tableBtnShape'"
                                :item="{
                                    ...item,
                                    rowId: scope.row.id,
                                    type: 'text',
                                }"
                                @rowDo="rowDo"
                            ></delPopConfirm>
                        </template>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg">
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <add
            :addVisible.sync="addVisible"
            :funcName="funcName"
        ></add>
        <edit
            :editVisible.sync="editVisible"
            :tableItem.sync="tableItem"
            :funcName="funcName"
        ></edit>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
        ></detail>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
/* 
import detail from "./metafileds/detail.vue"; */
import add from "./metafileds/add.vue";
import edit from "./metafileds/edit.vue";
export default {
    // 有些表格的相同部分 , 抽离在了tableMixins混合器里面
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            searchForm: {},
            searchForm_transfer: {},
            funcName: "metafileds",
            addVisible: false,
            editVisible: false,
            detailVisible: false,
            setMetafiledsVisible: false,
            selectList: [],
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    methods: {
        add() {
            this.addVisible = true;
        },
        del(item) {
            cmofferApi
                .metafileds({}, "delete", item.rowId)
                .then((res) => {
                    if (res) {
                        this.$message.success(
                            `${item.name} ${
                                this.$i18n.locale == "zh" ? "成功" : "Success"
                            }`
                        );
                        this.metafileds();
                    }
                })
                .catch(() => {});
        },
        // 获取产品集列表
        metafileds(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .metafileds(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.closeDrawer();
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                if (item.funcName == "add") {
                } else if (item.funcName == "edit") {
                    this.editVisible = true;
                    this.tableItem = row;
                } else if (item.funcName == "detail") {
                    /* this.setMetafiledsVisible = true;
                    this.tableItem = row; */
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },

        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        /**
         * 获取 sku组件回传的tags
         */
        getSkuTags(value) {
            this.searchForm.sku_list = value;
        },

        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.metafileds();
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        /* 
        detail, */
        add,
        edit,
    },
    computed: {},
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.metafileds {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
}
</style>
